import React, { useEffect } from "react";
import { RadixSelect } from "../../primitives/RadixSelect";
export var DropDownModifierContent = function (_a) {
    var groupName = _a.groupName, options = _a.options, selectedModifierId = _a.selectedModifierId, onSelect = _a.onSelect, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.highlightRequired, highlightRequired = _c === void 0 ? false : _c, _d = _a.requiredSatisfied, requiredSatisfied = _d === void 0 ? false : _d;
    var isRequirementSatisfied = requiredSatisfied || Boolean(selectedModifierId);
    useEffect(function () {
        if (options.length === 1 && !selectedModifierId) {
            onSelect(options[0].id);
        }
    }, [onSelect, options, selectedModifierId]);
    if (options.length <= 1) {
        return null;
    }
    return (React.createElement("div", { "data-required-group-name": groupName, className: ["item-customization-section", highlightRequired && !isRequirementSatisfied ? "item-customization-section--required-missing" : ""].filter(Boolean).join(" ") },
        React.createElement("div", { className: "item-customization-section-header" },
            React.createElement("h4", { className: "item-customization-section-title" }, groupName),
            required ? (React.createElement("span", { className: [
                    "item-customization-required-badge",
                    isRequirementSatisfied ? "item-customization-required-badge--satisfied" : "",
                    highlightRequired && !isRequirementSatisfied ? "item-customization-required-badge--missing" : ""
                ].filter(Boolean).join(" ") }, "Required")) : null),
        React.createElement(RadixSelect, { value: selectedModifierId, onChange: function (event) { return onSelect(event.target.value); }, options: options.map(function (option) { return ({ value: option.id, label: option.label }); }), placeholder: "Select an option", "aria-label": groupName })));
};
